import { render, staticRenderFns } from "./RoundRobin.vue?vue&type=template&id=0a684fd8"
import script from "./RoundRobin.vue?vue&type=script&lang=js"
export * from "./RoundRobin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports